<h3>History</h3>

@if (loading) {
  <div class="container">
    <mat-spinner style="margin: auto; vertical-align: baseline;" diameter=25 strokeWidth=4></mat-spinner>
  </div>
}

@if (!loading && discussionViewModels.length != 0) {
  <div>
    <ul class="history">
      @for (d of discussionViewModels; track d) {
        <li [class]="d.icon">
          <b>{{d.userName}} </b>
          <span [innerHtml]="d.description"></span>
          @if (d.timestamp != null) {
            <span [matTooltip]="d.formattedDate"> {{d?.timestamp?.seconds * 1000 | timeAgo}}</span>
          }</li>
        }
      </ul>
    </div>
  }

  @if (!loading && discussionViewModels.length == 0) {
    <div class="container">
      There is no history to display for this task
    </div>
  }
